import quickFetch from 'quick-fetch';
export const promisifyEarlyRequest = args => {
  const name = crypto.randomUUID();
  quickFetch.makeEarlyRequest(name, args);
  const request = quickFetch.getRequestStateByName(name);
  if (!request) {
    throw new Error(`Early request not found: ${name}`);
  }
  return new Promise((resolve, reject) => {
    request.whenFinished(result => {
      var _args$whenFinished;
      (_args$whenFinished = args.whenFinished) === null || _args$whenFinished === void 0 || _args$whenFinished.call(args, result);
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });
    request.onError((xhr, message) => {
      var _args$onError;
      (_args$onError = args.onError) === null || _args$onError === void 0 || _args$onError.call(args, xhr, message);
      reject(new Error(`Early request failed: ${message}`));
      quickFetch.removeEarlyRequest(name);
    });
  });
};